import { removeAll } from '../../thing/remove.mjs';
import { addIri } from '../../thing/add.mjs';
import { ACL } from '../constants.mjs';

//
/** @hidden */
function setModes(policy, modes, type) {
    let newPolicy = removeAll(policy, type);
    if (modes.read || modes.controlRead) {
        newPolicy = addIri(newPolicy, type, ACL.Read);
    }
    if (modes.append) {
        newPolicy = addIri(newPolicy, type, ACL.Append);
    }
    if (modes.write || modes.controlWrite) {
        newPolicy = addIri(newPolicy, type, ACL.Write);
    }
    return newPolicy;
}

export { setModes };
